import { render, staticRenderFns } from "./ReportingCategoryHistory.vue?vue&type=template&id=099a48dd"
import script from "./ReportingCategoryHistory.vue?vue&type=script&lang=js"
export * from "./ReportingCategoryHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports